var klaviyo = klaviyo || [];
klaviyo.init({
  account: "Qsuc2S",
  platform: "shopify"
});
klaviyo.enable("backinstock",{ 
trigger: {
  product_page_text: "Notify me when the item is in stock",
  product_page_class: "hc-add-trigger",
  product_page_text_align: "center",
  product_page_margin: "0px",
  replace_anchor: true
},
modal: {
 headline: "{product_name}",
 body_content: "Sign up to get notified when this item is back in stock.",
 email_field_label: "Email",
 button_label: "Notify me when the item is in stock",
 subscription_success_label: "You're on the list! We'll notify you when the item is back in stock.",
 footer_content: '',
 additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
 drop_background_color: "#000",
 background_color: "#fff",
 text_color: "#222",
 button_text_color: "#fff",
 button_background_color: "#5e8671",
 close_button_color: "#ccc",
 error_background_color: "#fcd6d7",
 error_text_color: "#C72E2F",
 success_background_color: "#d3efcd",
 close_label: "Close",
 success_text_color: "#1B9500"
}
});